module.exports = __webpack_public_path__ + "img/5.e887c0a5.svg";